import { css } from '@emotion/react'
import { mdiHeart } from '@mdi/js'
import { Icon } from '@mdi/react'
import { memo } from 'react'

import type { IconProps } from '.'
import { palette } from '../styles/colors'
// <Icon css={activeIconColor} {...props} />

const activeIconColor = css({
    color: palette.activeGreen,
})

const Friended = memo((props: IconProps) => {
    const { filled, color, size = 1, title, ...other } = props
    return (
        <Icon
            css={activeIconColor}
            data-testid="IconButton__Friended"
            path={mdiHeart}
            title={title}
            size={size}
            color={color}
            {...other}
        />
    )
})

export default Friended
